export const COMPLETE = 'COMPLETE';
export const REJECTED = 'REJECTED';
export const WARNING = 'WARNING';
